import { useParams } from "react-router-dom";
import FormEmpresa from "./formEmpresa";

export function EmpresaEditar() {
  const idempresa = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <FormEmpresa idempresa={idempresa.id} acao="Editar" />
      </div>
    </>
  );
}
